import React from 'react';
import PropTypes from 'prop-types';
import useTableOfContents from '../hooks/useTableOfContents';


const TableOfContents = ({ containerSelector }) => {
    const tocItems = useTableOfContents(containerSelector);

    const handleClick = (id) => {
        const el = document.getElementById(id);
        if (el) {
            const yOffset = -100;
            const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    if (!tocItems.length) return null;

    return (
        <div className="common-wrapper mb-4 position-relative">
            <h3 className="mb-4 fw-500 text-uppercase text-4">Table of Contents</h3>
            <ul className="toc-list">
                {tocItems.map(({ id, text, level }, index) => (
                    <li
                        key={id}
                        className={`toc-item toc-${level}`}
                        onClick={() => handleClick(id)}
                    >
                        <span className="toc-serial">{index + 1}.</span><span className="toc-heading">{text}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

TableOfContents.propTypes = {
    containerSelector: PropTypes.string,
};

TableOfContents.defaultProps = {
    containerSelector: '#blog-content',
};

export default TableOfContents;